import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, from, throwError } from 'rxjs'
import { take } from 'rxjs/operators'
import { AuthService } from './auth.service'
import { snapshot$ } from 'src/firebase-utils'
import { Firestore, collection, doc, setDoc, updateDoc } from '@angular/fire/firestore'
import { HandleErrorService } from './log.service'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private http = inject(HttpClient);


  firestore = inject(Firestore)
  authService = inject(AuthService)
  errorHandler = inject(HandleErrorService)
  notificationRef = collection(this.firestore, 'notifications')
  userRef$ = snapshot$(this.authService.userRef)

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    // this.errorHandler.log('Notifications Service Initialized')
  }

  async setNotification(user, title, message) {

    let date = new Date().getTime()

    let notification = {
      read: false,
      date,
      title,
      message
    }

    this.userRef$.pipe(take(1)).subscribe((users: any) => {
      
      let actualUser = users.find((u) => u.uid === user)
      if(actualUser.mail_notifications) {

        let headers = {
          'Authorization': 'Basic 023ff24c5cc8e81d20db9c22a99052f7b8dc4c00aec9cb45b746f0281d63ff84',
          'Content-Type': 'application/json'
        }

        this.http.post(`${environment.defaultReferenceServer}/mailsend/mailsend`, {target: actualUser.email, title, contents: message}, {headers}).subscribe()
      }
    })

    const docRef = doc(this.notificationRef, user)

    try {
      return await updateDoc(docRef, {[date]: notification})
    } catch(err) {
      if(err.code === 'not-found') {
        return await setDoc(docRef, {[date]: notification})
      }

      this.errorHandler.log(err)
    }
  }

  streamNotifications(id: string): Observable<any> {
    try {
      const docRef = doc(this.notificationRef, id)
      return snapshot$(docRef)
    } catch(err) {
      return throwError(() => {
        this.errorHandler.log(err)
        return new Error(err)
      })
    }
  }

  async updateNotification(id: string, value: any) {
    try {
      const docRef = doc(this.notificationRef, id)
      await updateDoc(docRef, value)
    } catch(err) {
      this.errorHandler.log(err)
    }
  }
}
